import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const vinRecordRouter = {
  path: '/themes',
  component: Management,
  redirect: '/themes/index',
  children: [
    {
      path: 'index',
      component: () => import('@/views/themes/Index'),
      meta: {
        auth: Auth.common
      }
    }
    // router mark
  ]
}

export default vinRecordRouter
